/* FIG — custom elements cho theme bộ 2 (clone snapfigures.com). Không dùng thư viện ngoài. */

/** Rail cuộn ngang: track .fig-rail__track, nút [data-dir="prev"|"next"]. */
class FigRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.fig-rail__track');
    if (!this.track) return;
    this.querySelectorAll('[data-dir]').forEach((btn) => btn.addEventListener('click', () => this.scrollByDir(btn.dataset.dir)));
  }
  scrollByDir(dir) {
    const first = this.track.firstElementChild;
    const step = first ? first.getBoundingClientRect().width + 20 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: dir === 'prev' ? -step * 2 : step * 2, behavior: 'smooth' });
  }
}
customElements.define('fig-rail', FigRail);

/** Card video: bấm play → nhúng YouTube/Vimeo (data-youtube / data-vimeo); không có video → đi tới data-link. */
class FigVideo extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-play]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const { youtube, vimeo, link } = this.dataset;
      if (youtube || vimeo) {
        const frame = document.createElement('iframe');
        frame.src = youtube
          ? `https://www.youtube.com/embed/${youtube}?autoplay=1&rel=0`
          : `https://player.vimeo.com/video/${vimeo}?autoplay=1`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        frame.className = 'fig-video__frame';
        this.querySelector('.fig-video__media').replaceChildren(frame);
        btn.remove();
      } else if (link) {
        window.location.href = link;
      }
    });
  }
}
customElements.define('fig-video', FigVideo);

/**
 * Form sản phẩm custom: option pill → chọn variant, giá đổi theo variant, bundle 1/2/3,
 * upload ảnh/file (kiểm tra dung lượng, preview), Buy now → return_to=/checkout.
 * Form POST thường (multipart) tới /cart/add để file được lưu vào line item property.
 */
class FigProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    const data = this.querySelector('[data-variants]');
    if (!this.form || !data) return;
    this.variants = JSON.parse(data.textContent);
    this.money = this.dataset.money || '{{amount}}';
    this.idInput = this.form.querySelector('[data-variant-id]');
    this.form.querySelectorAll('.fig-opt input').forEach((i) => i.addEventListener('change', () => this.update()));
    this.form.querySelectorAll('[data-bundles] button').forEach((b) => b.addEventListener('click', () => this.setBundle(b)));
    this.form.querySelectorAll('input[type="file"]').forEach((i) => i.addEventListener('change', () => this.preview(i)));
    const qty = this.form.querySelector('[data-qty-input]');
    if (qty) qty.addEventListener('input', () => this.syncBundle(Number(qty.value)));
    const buyNow = this.form.querySelector('[data-buy-now]');
    const returnTo = this.form.querySelector('[name="return_to"]');
    if (buyNow && returnTo) buyNow.addEventListener('click', () => { returnTo.value = '/checkout'; });
    this.form.addEventListener('submit', (e) => { if (!this.validate()) e.preventDefault(); });
    this.initSticky();
    this.update();
  }

  /** Mobile: hiện thanh sticky khi khối nút Add to cart / Buy now ra khỏi màn hình. */
  initSticky() {
    const bar = this.querySelector('[data-sticky]');
    const actions = this.form.querySelector('.fig-pform__actions');
    if (!bar || !actions || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting; }).observe(actions);
  }

  selected() {
    return [...this.form.querySelectorAll('.fig-opt')].map((fs) => (fs.querySelector('input:checked') || {}).value);
  }

  update() {
    const sel = this.selected();
    const keys = ['option1', 'option2', 'option3'].slice(0, sel.length);
    const match = (v, skip) => keys.every((k, i) => i === skip || v[k] === sel[i]);
    const variant = this.variants.find((v) => match(v, -1));

    this.form.querySelectorAll('.fig-opt').forEach((fs, i) => {
      fs.querySelectorAll('input').forEach((inp) => {
        const ok = this.variants.some((v) => v.available && v[keys[i]] === inp.value && match(v, i));
        inp.closest('.fig-opt__pill').classList.toggle('is-unavailable', !ok);
      });
    });

    const price = this.querySelector('[data-price]');
    const compare = this.querySelector('[data-compare]');
    const add = this.form.querySelector('[data-submit]');
    const buy = this.form.querySelector('[data-buy-now]');
    const sticky = this.querySelector('[data-sticky-submit]');
    const stickyPrice = this.querySelector('[data-sticky-price]');
    if (!variant) {
      if (this.idInput) this.idInput.value = '';
      if (add) { add.disabled = true; add.textContent = this.dataset.unavailableText || 'Unavailable'; }
      if (buy) buy.disabled = true;
      if (sticky) sticky.disabled = true;
      return;
    }
    if (this.idInput) this.idInput.value = variant.id;
    if (price) price.textContent = this.fmt(variant.price);
    if (stickyPrice) stickyPrice.textContent = this.fmt(variant.price);
    if (sticky) sticky.disabled = !variant.available;
    if (compare) {
      const show = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !show;
      if (show) compare.textContent = this.fmt(variant.compare_at_price);
    }
    if (add) { add.disabled = !variant.available; add.textContent = variant.available ? (this.dataset.addText || 'Add to cart') : (this.dataset.soldOutText || 'Sold out'); }
    if (buy) buy.disabled = !variant.available;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(null, '', url);
    } catch (e) { /* bỏ qua */ }
  }

  setBundle(btn) {
    const qty = Number(btn.dataset.qty) || 1;
    const input = this.form.querySelector('[data-qty-input]');
    if (input) input.value = qty;
    this.syncBundle(qty, btn);
  }

  /** Đồng bộ nút bundle + property "Bundle" theo số lượng (property chỉ gửi khi qty ≥ 2). */
  syncBundle(qty, activeBtn) {
    const buttons = [...this.form.querySelectorAll('[data-bundles] button')];
    const active = activeBtn || buttons.find((b) => Number(b.dataset.qty) === qty);
    buttons.forEach((b) => b.classList.toggle('is-active', b === active));
    const prop = this.form.querySelector('[data-bundle-prop]');
    if (prop) {
      prop.disabled = !(active && qty >= 2);
      prop.value = active ? active.dataset.label || '' : '';
    }
  }

  preview(input) {
    const slot = input.closest('.fig-upload__slot');
    const img = slot.querySelector('.fig-upload__preview');
    const name = slot.querySelector('.fig-upload__name');
    const file = input.files && input.files[0];
    slot.classList.toggle('has-file', !!file);
    if (!file) { img.hidden = true; name.textContent = ''; return; }
    name.textContent = `${file.name} · ${(file.size / 1048576).toFixed(1)} MB`;
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => { img.src = reader.result; img.hidden = false; };
      reader.readAsDataURL(file);
    } else {
      img.hidden = true;
    }
  }

  validate() {
    const err = this.querySelector('[data-error]');
    const problems = [];
    this.form.querySelectorAll('input[type="file"]').forEach((input) => {
      const max = Number(input.dataset.maxMb) || 20;
      const file = input.files && input.files[0];
      if (file && file.size > max * 1048576) problems.push(`${file.name} is over ${max} MB.`);
    });
    if (err) { err.textContent = problems.join(' '); err.hidden = problems.length === 0; }
    return problems.length === 0;
  }

  /** Định dạng tiền theo shop.money_format ({{amount}}, {{amount_no_decimals}}, …). Giá trị vào là cents. */
  fmt(cents) {
    const value = cents / 100;
    const format = this.money;
    const noDecimals = /no_decimals/.test(format);
    let out = noDecimals
      ? Math.round(value).toLocaleString('en-US')
      : value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (/comma_separator/.test(format)) out = out.replace(/,/g, '§').replace(/\./g, ',').replace(/§/g, '.');
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, out);
  }
}
customElements.define('fig-product-form', FigProductForm);
